<template>
  <div class="info-setting-page">
    <div class="welcome-bar">
      <p class="welcome-text">
        &nbsp;&nbsp;尊敬的XXX，您是盘雷第X位用户，盘雷是一个完全免费开放的数字供应链平台，您既可在此进行销售与采购，也可将手中资源转化为生态红利；通过邀请您的上下游伙伴，不仅能提升工作效率，享受平台权益，还有机会借此次永久免费使用盘雷甚至实现盈利。您也可直接购买会员，一键获取特定地区或品牌的全量供应商资源。欢迎您尽快完成推广者等级学习以掌握各项工具，待达到2级并填写下方资料后，即可申请成为盘雷开发者合伙人，共享深度资源与持续收益。
      </p>
    </div>
    <div class="module-container">
      <div class="module">
        <h3 class="module-title">您的安全服务</h3>
        <el-form :model="securityForm" label-width="100px" class="security-form">
          <el-form-item label="登录密码:">
            <div class="password-row">
              <el-input
                v-model="securityForm.loginPwd"
                type="password"
                show-password
                placeholder="******"
                disabled
                style="width: 200px"
              />
              <el-button type="text" class="modify-link" @click="togglePasswordPanel">
                {{ showPasswordPanel ? '收起修改方式' : '修改密码' }}
              </el-button>
            </div>
            <div class="form-tip">安全性高的密码可以使账号更安全，建议您定期更换密码</div>
            <div v-if="showPasswordPanel" class="password-panel">
              <el-tabs v-model="activePasswordTab">
                <el-tab-pane label="通过原密码方式" name="1">
                  <div class="password-form-wrap">
                    <el-form
                      ref="passwordFormRef"
                      :model="passwordForm"
                      :rules="passwordRules"
                      label-width="100px"
                    >
                      <el-form-item label="原密码:" prop="oldPassword">
                        <el-input
                          v-model="passwordForm.oldPassword"
                          :name="`old-password-${passwordInputSeed}`"
                          autocomplete="off"
                          placeholder="请输入原密码"
                          clearable
                        />
                      </el-form-item>
                      <el-form-item label="新密码:" prop="password">
                        <el-input
                          v-model="passwordForm.password"
                          :name="`new-password-${passwordInputSeed}`"
                          autocomplete="off"
                          placeholder="请输入新密码"
                          clearable
                        />
                      </el-form-item>
                      <el-form-item label="确认密码:" prop="confirmPassword">
                        <el-input
                          v-model="passwordForm.confirmPassword"
                          :name="`confirm-password-${passwordInputSeed}`"
                          autocomplete="off"
                          placeholder="请确认新密码"
                          clearable
                        />
                      </el-form-item>
                    </el-form>
                  </div>
                  <div class="password-action">
                    <el-button type="primary" size="small" @click="handlePasswordConfirm">
                      保存
                    </el-button>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="通过手机验证码方式" name="2">
                  <forget-password notShowBack @changePage="handleForgetPasswordChange" />
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-form-item>

          <el-form-item label="手机号:">
            <el-input v-model="securityForm.phone" disabled placeholder="18982112314" style="width: 200px" />
            <div class="form-tip"></div>
          </el-form-item>

          <el-form-item label="绑定微信:" class="wechat-form-item">
            <div class="wechat-card">
              <div class="wechat-card__main">
                <div class="wechat-icon-wrap">
                  <img :src="wechatBindState ? wechatBindImg : wechatNoBindImg" alt="微信" class="wechat-icon" />
                </div>
                <div class="wechat-meta">
                  <div class="wechat-title-row">
                    <span class="wechat-name">微信账号</span>
                    <span :class="['wechat-status', wechatBindState ? 'is-bound' : 'is-unbound']">
                      {{ wechatBindState ? '已绑定' : '未绑定' }}
                    </span>
                  </div>
                  <div class="wechat-desc">
                    绑定微信之后，你可以使用微信扫码登录；解绑时需要短信验证码校验。
                  </div>
                </div>
              </div>
              <div class="wechat-actions">
                <el-button v-if="wechatBindState" plain size="small" @click="openUnbindDialog">
                  解绑微信
                </el-button>
                <el-button v-else type="primary" size="small" @click="openBindDialog">
                  立即绑定
                </el-button>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="绑定邮箱:">
            <div class="bind-row">
              <el-input v-model="securityForm.email" disabled placeholder="1394088@qq.com" style="width: 200px" />
              <el-button size="small" @click="unbindEmail">解绑</el-button>
              <el-button type="primary" size="small" @click="bindEmail">立即绑定</el-button>
            </div>
            <div class="form-tip">验证邮箱可加强账户安全，您可以使用已验证的邮箱快速找回密码</div>
          </el-form-item>

          <el-form-item label="支付密码:">
            <el-input
              v-model="securityForm.payPwd"
              type="password"
              show-password
              placeholder="请输入密码"
              style="width: 200px"
            />
            <div class="form-tip">请设置您的支付密码</div>
          </el-form-item>
        </el-form>
      </div>

      <div class="module">
        <h3 class="module-title">实名认证</h3>
        <el-form :model="authForm" label-width="100px" class="auth-form">
          <el-form-item label="真实姓名:">
            <el-input v-model="authForm.realName" placeholder="请输入密码" style="width: 300px" />
            <div class="form-tip">为确保您的账户安全，请填写您本人的实名认证信息</div>
          </el-form-item>

          <el-form-item label="国籍(地区):">
            <el-select v-model="authForm.country" placeholder="中国内地" style="width: 300px">
              <el-option label="中国内地" value="cn" />
              <el-option label="中国香港" value="hk" />
              <el-option label="中国澳门" value="mo" />
              <el-option label="中国台湾" value="tw" />
            </el-select>
          </el-form-item>

          <el-form-item label="证件类型:">
            <el-select v-model="authForm.idType" placeholder="身份证" style="width: 300px">
              <el-option label="身份证" value="idCard" />
              <el-option label="护照" value="passport" />
            </el-select>
          </el-form-item>

          <el-form-item label="证件号码:">
            <el-input v-model="authForm.idNo" placeholder="请输入正确的证件号码" style="width: 300px" />
          </el-form-item>

          <el-form-item label="银行卡号:">
            <div class="bank-card-row">
              <el-input
                v-model="authForm.bankCard"
                placeholder="请输入银行卡号"
                class="bank-input"
                style="width: 300px"
              />
              <span class="support-bank-text">支持银行</span>
            </div>
            <div class="form-tip">仅支持您本人名下的银行卡，输入卡号自动识别银行卡币种</div>
          </el-form-item>

          <el-form-item label="手机号码:">
            <el-input v-model="authForm.bankPhone" placeholder="请输入手机号码" style="width: 300px" />
            <div class="form-tip">请填写该卡在银行预留的手机号码，验证该银行卡是否真实属于您本人</div>
          </el-form-item>

          <el-form-item label="验证码:">
            <div class="code-row">
              <el-input v-model="authForm.code" placeholder="请输入验证码" style="width: 200px" />
              <el-button type="primary" size="small" @click="getCode">获取验证码</el-button>
            </div>
            <div class="form-tip">
              <el-button type="text" size="small" class="resend-btn">没有收到验证码?</el-button>
            </div>
          </el-form-item>

          <el-form-item label="实名授权:">
            <el-radio-group v-model="authForm.authGrant">
              <el-radio label="yes">是</el-radio>
              <el-radio label="no">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>

      <div class="module">
        <h3 class="module-title">我的银行卡</h3>
        <div class="bank-tip">我的银行卡 已添加0张信用卡，0张储蓄卡</div>
        <div class="add-bank-card">
          <div class="add-icon">+</div>
          <span class="add-text">添加银行卡</span>
        </div>
      </div>

      <div class="action-buttons">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确认</el-button>
      </div>
    </div>
  </div>

  <el-dialog v-model="wechatDialogVisible" width="420px" class="wechat-bind-dialog">
    <div class="wechat-dialog-body">
      <div class="wechat-dialog-title">微信扫码绑定</div>
      <div class="wechat-dialog-desc">请使用微信扫描下方二维码完成账号绑定</div>
      <div class="wechat-qrcode-wrap">
        <wxlogin
          self_redirect="false"
          appid="wx75ee94f1e9d5bc07"
          scope="snsapi_login"
          :redirect_uri="wechatRedirectUri"
        />
      </div>
    </div>
  </el-dialog>

  <el-dialog v-model="wechatUnbindDialogVisible" width="460px" class="wechat-unbind-dialog">
    <div class="wechat-dialog-body">
      <div class="wechat-dialog-title">解除微信绑定</div>
      <div class="wechat-dialog-desc">解除绑定后将不能使用微信账号登录盘雷</div>
      <el-form :model="wechatUnbindForm" label-width="84px" class="wechat-unbind-form">
        <el-form-item label="手机号">
          <el-input v-model="wechatUnbindForm.phone" placeholder="请输入手机号" />
        </el-form-item>
        <div class="wechat-code-row">
          <el-form-item label="验证码" class="wechat-code-item">
            <el-input v-model="wechatUnbindForm.code" placeholder="请输入验证码" />
          </el-form-item>
          <el-button
            type="primary"
            plain
            size="small"
            class="wechat-code-button"
            :disabled="wechatCodeSecond !== 0"
            @click="sendWechatCode"
          >
            {{ wechatCodeText }}
          </el-button>
        </div>
        <div class="wechat-dialog-footer">
          <el-button @click="wechatUnbindDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmUnbindWechat">确认解绑</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import wxlogin from 'vue-wxlogin'
import forgetPassword from '../../loginModule/components/forgetPassword.vue'

const store = useStore()
const route = useRoute()
const router = useRouter()

const securityForm = reactive({
  loginPwd: '******',
  phone: '18982112314',
  email: '1394088@qq.com',
  payPwd: ''
})

const userInfo = reactive({})
const wechatBindImg = require('@/assets/wechat.png')
const wechatNoBindImg = require('@/assets/WechatGray.png')
const wechatDialogVisible = ref(false)
const wechatUnbindDialogVisible = ref(false)
const wechatCodeSecond = ref(0)
const wechatCodeTimer = ref(null)
const wechatUnbindForm = reactive({
  phone: '',
  code: ''
})

const authForm = reactive({
  realName: '',
  country: 'cn',
  idType: 'idCard',
  idNo: '',
  bankCard: '',
  bankPhone: '',
  code: '',
  authGrant: 'yes'
})

const showPasswordPanel = ref(false)
const activePasswordTab = ref('1')
const passwordFormRef = ref(null)
const passwordInputSeed = Date.now()
const passwordForm = reactive({
  oldPassword: '',
  password: '',
  confirmPassword: ''
})

const passwordRules = {
  oldPassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
  password: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
  confirmPassword: [{ required: true, message: '请确认新密码', trigger: 'blur' }]
}

const wechatBindState = computed(() => userInfo.wechatFlag === '1')
const wechatCodeText = computed(() => {
  return wechatCodeSecond.value === 0 ? '获取验证码' : `${wechatCodeSecond.value}s后重新获取`
})
const wechatRedirectUri = computed(() => {
  return encodeURIComponent('https://www.panlei.cn/personal/index')
})

const togglePasswordPanel = () => {
  showPasswordPanel.value = !showPasswordPanel.value
  if (showPasswordPanel.value) {
    activePasswordTab.value = '1'
  }
}

const resetPasswordForm = () => {
  passwordForm.oldPassword = ''
  passwordForm.password = ''
  passwordForm.confirmPassword = ''
  if (passwordFormRef.value) {
    passwordFormRef.value.clearValidate()
  }
}

const handlePasswordConfirm = async () => {
  if (!passwordFormRef.value) {
    return
  }
  const valid = await passwordFormRef.value.validate().catch(() => false)
  if (!valid) {
    return
  }
  if (passwordForm.confirmPassword !== passwordForm.password) {
    ElMessage({
      type: 'warning',
      message: '两次输入的密码不一致'
    })
    return
  }
  const params = {
    oldPassword: passwordForm.oldPassword,
    password: passwordForm.password
  }
  const res = await store.dispatch('systemModule/userPassword', params)
  const { code } = res.data || {}
  if (code === '0') {
    ElMessage({
      type: 'success',
      message: '修改成功'
    })
    resetPasswordForm()
    showPasswordPanel.value = false
  }
}

const handleForgetPasswordChange = page => {
  if (page === 'login') {
    activePasswordTab.value = '1'
    showPasswordPanel.value = false
  }
}

const fetchUserInfo = async () => {
  const res = await store.dispatch('systemModule/getUserInfo')
  const { code, data } = res.data || {}
  if (code === '0' && data) {
    Object.assign(userInfo, data)
    store.commit('renewUserInfo', data)
    securityForm.phone = data.bindPhone
  }
}

const resetWechatCodeTimer = () => {
  if (wechatCodeTimer.value) {
    clearInterval(wechatCodeTimer.value)
    wechatCodeTimer.value = null
  }
  wechatCodeSecond.value = 0
}

const openBindDialog = () => {
  wechatDialogVisible.value = true
}

const openUnbindDialog = () => {
  wechatUnbindForm.phone = userInfo.bindPhone || ''
  wechatUnbindForm.code = ''
  wechatUnbindDialogVisible.value = true
}

const sendWechatCode = async () => {
  if (!wechatUnbindForm.phone) {
    ElMessage({
      message: '请输入手机号',
      type: 'warning'
    })
    return
  }
  const res = await store.dispatch('loginModule/smsCode', wechatUnbindForm.phone)
  const { code } = res.data || {}
  if (code === '0') {
    ElMessage({
      message: '发送成功',
      type: 'success'
    })
    wechatCodeSecond.value = 60
    resetWechatCodeTimer()
    wechatCodeSecond.value = 60
    wechatCodeTimer.value = setInterval(() => {
      if (wechatCodeSecond.value > 0) {
        wechatCodeSecond.value -= 1
      } else {
        resetWechatCodeTimer()
      }
    }, 1000)
  }
}

const confirmUnbindWechat = async () => {
  if (!wechatUnbindForm.phone || !wechatUnbindForm.code) {
    ElMessage({
      message: '请输入手机号和验证码',
      type: 'warning'
    })
    return
  }
  const validateRes = await store.dispatch(
    'loginModule/smsCodeV',
    `?phone=${wechatUnbindForm.phone}&code=${wechatUnbindForm.code}`
  )
  const { code } = validateRes.data || {}
  if (code !== '0') {
    ElMessage({
      type: 'error',
      message: '验证失败'
    })
    return
  }
  const unbindRes = await store.dispatch('systemModule/uBindCancelBind')
  const { code: unbindCode } = unbindRes.data || {}
  if (unbindCode === '0') {
    ElMessage({
      type: 'success',
      message: '解绑成功'
    })
    wechatUnbindDialogVisible.value = false
    wechatUnbindForm.code = ''
    await fetchUserInfo()
  }
}

const handleWechatBindCallback = async () => {
  const code = route.query.code
  if (!code) {
    return
  }
  const localUserInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
  if (!localUserInfo.userId) {
    return
  }
  const res = await store.dispatch('uWechatBind', `?code=${code}&userId=${localUserInfo.userId}`)
  const { code: bindCode } = res.data || {}
  if (bindCode === '0') {
    ElMessage({
      type: 'success',
      message: '绑定成功'
    })
    wechatDialogVisible.value = false
    await fetchUserInfo()
    const nextQuery = { ...route.query }
    delete nextQuery.code
    router.replace({
      path: route.path,
      query: nextQuery
    })
  }
}

const unbindEmail = () => {}
const bindEmail = () => {}
const getCode = () => {}
const handleCancel = () => {}
const handleConfirm = () => {}

onMounted(async () => {
  await fetchUserInfo()
  await handleWechatBindCallback()
})

onBeforeUnmount(() => {
  resetPasswordForm()
  resetWechatCodeTimer()
})
</script>

<style lang="less" scoped>
.info-setting-page {
  max-width: 1400px;
  margin: 0 auto;
}

.welcome-bar {
  background: #ffffff;
  padding: 35px 20px;
  height: 130px;
  border-radius: 4px;
  box-sizing: border-box;
  margin-bottom: 24px;
}

.welcome-text {
  font-size: 14px;
  color: #303133;
  line-height: 1.6;
  margin: 0;
}

.module-container {
  margin-bottom: 32px;
  background: #ffffff;
  padding: 20px;
  border-radius: 4px;
}

.module-title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 16px;
  border-left: 3px solid #48a09c;
  padding-left: 8px;
  line-height: 1.2;
}

.security-form,
.auth-form {
  :deep(.el-form-item) {
    margin-bottom: 16px;
  }
}

.password-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.modify-link {
  color: #409eff;
  padding: 0;
}

.password-panel {
  width: 520px;
  margin-top: 12px;
  padding: 16px 20px 8px;
  background: #f7f9fc;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

.password-form-wrap {
  display: flex;
  justify-content: center;
}

.password-action {
  text-align: center;
}

.password-panel :deep(.el-form-item__content) {
  margin-left: 0 !important;
}

.wechat-form-item :deep(.el-form-item__content) {
  display: block;
}

.wechat-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  max-width: 720px;
  padding: 16px 18px;
  background: #f8fbfb;
  border: 1px solid #e6f0ef;
  border-radius: 8px;
}

.wechat-card__main {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.wechat-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid #e9efef;
  flex-shrink: 0;
}

.wechat-icon {
  width: 30px;
  height: 30px;
  object-fit: contain;
}

.wechat-meta {
  min-width: 0;
}

.wechat-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}

.wechat-name {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.wechat-status {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 12px;
}

.wechat-status.is-bound {
  color: #1f8f63;
  background: #e8f7ef;
}

.wechat-status.is-unbound {
  color: #b26a00;
  background: #fff4de;
}

.wechat-desc {
  font-size: 12px;
  line-height: 1.7;
  color: #7a838f;
}

.wechat-actions {
  flex-shrink: 0;
}

.wechat-dialog-body {
  padding: 6px 4px 10px;
}

.wechat-dialog-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  text-align: center;
}

.wechat-dialog-desc {
  margin-top: 8px;
  font-size: 13px;
  line-height: 1.6;
  color: #7a838f;
  text-align: center;
}

.wechat-qrcode-wrap {
  display: flex;
  justify-content: center;
  margin-top: 18px;
}

.wechat-unbind-form {
  margin-top: 18px;
}

.wechat-code-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.wechat-code-item {
  flex: 1;
}

.wechat-code-button {
  margin-top: 4px;
  min-width: 110px;
  color: #48a09c !important;
  background: #eff8f7 !important;
  border-color: #b8ddda !important;
}

.wechat-code-button:hover,
.wechat-code-button:focus {
  color: #ffffff !important;
  background: #48a09c !important;
  border-color: #48a09c !important;
}

.wechat-code-button.is-disabled,
.wechat-code-button.is-disabled:hover,
.wechat-code-button.is-disabled:focus {
  color: #a0a7b4 !important;
  background: #f4f6f8 !important;
  border-color: #d9dee5 !important;
}

.wechat-dialog-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 18px;
}

.bind-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.form-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.bank-card-row {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.bank-input {
  flex: 1;
  max-width: 300px;
}

.support-bank-text {
  font-size: 16px;
  color: #48a09c;
  white-space: nowrap;
}

.code-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.resend-btn {
  color: #409eff;
  padding: 0;
}

.bank-tip {
  font-size: 14px;
  color: #606266;
  margin-bottom: 16px;
}

.add-bank-card {
  width: 120px;
  height: 80px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.add-icon {
  font-size: 24px;
  color: #c0c4cc;
  margin-bottom: 4px;
}

.add-text {
  font-size: 12px;
  color: #909399;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 32px;
}
</style>
